import React from "react";
import { Button } from "@src/components/ui/button";
import { usePromptInputAttachments } from "@src/components/ai-elements/prompt-input-context/usePromptInputAttachments";

/**
 * Plus button wired to `PromptInputProvider`'s `openFileDialog`. We render
 * a standalone button (not the dropdown-item variant) so it can sit
 * directly next to the model selector without a wrapping menu.
 */
export const AddAttachmentsButton = () => {
  const attachments = usePromptInputAttachments();
  return (
    <Button
      aria-label="Add attachment"
      className="hover:bg-foreground/10"
      onClick={() => attachments.openFileDialog()}
      size="icon"
      type="button"
      variant="ghost"
    >
      <PaperclipGlyph />
    </Button>
  );
};

const PaperclipGlyph: React.FC = () => (
  <svg
    aria-hidden
    fill="none"
    height={16}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    viewBox="0 0 24 24"
    width={16}
  >
    <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);
